import styled, { css } from 'styled-components';
import * as colors from '../../../../../../config/Colors/Ligth';

interface IContainerProps {
  estoque_negativo: boolean;
  alocado: boolean;
}

export const Container = styled.div<IContainerProps>`
  width: 100%;
  height: auto;

  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  border-radius: 4px;
  border: 1px solid ${colors.borderColor};
  box-shadow: 0px 2px 1px -1px rgba(0, 0, 0, 0.2),
    0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12);
  padding: 10px;
  margin: 3px 0;
  background-color: white;
  ${props =>
    props.alocado &&
    css`
      border: 1px solid ${colors.concluido};
    `}
  div {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-start;
    h1 {
      font-size: 1.2rem;
      font-family: 'Roboto', 'Helvetica', 'Arial', sans-serif;
      font-weight: 400;
      line-height: 1.334;
      letter-spacing: 0em;
      color: rgba(0, 0, 0, 0.87);
    }
    div {
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: baseline;
      flex: 1;
      height: 100%;
      div {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        height: 100%;
      }
      & + div {
        flex: 1;
        height: 100%;
        align-items: flex-end;
        justify-content: baseline;
      }
    }
  }

  button {
    padding: 0;
    display: flex;
    justify-content: flex-end;
    height: 100%;
  }

  small {
    font-size: 0.8rem;
    font-family: 'Roboto', 'Helvetica', 'Arial', sans-serif;
    font-weight: 400;
    line-height: 1.75;
    letter-spacing: 0.00938em;
    margin-bottom: 5px;
    color: ${colors.etapa_concluida};
    ${props =>
    props.estoque_negativo &&
    css`
        color: ${colors.erro};
      `};
  }
`;

export const ContainerGrupoProduto = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: auto;
  padding: 3px 0;
  p {
    background-color: #f4f2f5;
    font-size: 10px;
    font-weight: 500;
    padding: 0 2px;
    border-radius: 4px;
  }
`;

export const ContainerInput = styled.div`
  position: relative;
  display: inline-block;
  border-bottom: 2px solid ${colors.borderColor};

  padding-right: 5px;
  input {
    text-align: center;
    font-size: 1.2rem;
    font-family: 'Roboto', 'Helvetica', 'Arial', sans - serif;
    font-weight: 400;
    line-height: 2rem;
    letter-spacing: 0em;
    padding: 0 5px;
    margin-right: 5px;
    color: rgba(0, 0, 0, 0.87);
    width: 100px;
    border: none;
  }
`;

export const Precos = styled.div`
  display: flex;
  color: rgba(0, 0, 0, 0.54);
  p {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1rem;
    font-family: 'Roboto', 'Helvetica', 'Arial', sans - serif;
    font-weight: 400;
    letter-spacing: 0em;
    color: ${colors.ligthFontColor};
  }
  h1 {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.3rem !important;
    color: ${colors.darkFontColor};
    svg {
      color: ${colors.ligthFontColor};
    }
  }
`;
